import {
    deleteHeaders,
    fetchHeaders,
    patchHeaders,
    postJsonHeaders,
} from "../../utils/headers";
import Constants from "../../utils/constants";

export const conteneursService = {
    fetchConteneurs,
    fetchConteneursForPatrimoine,
    fetchConteneur,
    deleteConteneur,
    createConteneur,
    updateConteneur,
};

function fetchConteneurs(containerId) {
    const requestOptions = fetchHeaders()

    return fetch(Constants.API_ROUTE_CONTENEURS, requestOptions)
        .then(handleResponse)
        .then(conteneurs => {
            return conteneurs["hydra:member"]
        });
}

function fetchConteneursForPatrimoine(patrimoineId) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_CONTENEURS + "?patrimoineId="+patrimoineId

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(conteneurs => {
            return conteneurs["hydra:member"]
        });
}

function fetchConteneur(id) {
    const requestOptions = fetchHeaders()

    let url = Constants.API_ROUTE_CONTENEUR.replace(':id', id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(conteneur => {
            return conteneur
        });
}

function createConteneur(values) {
    const requestOptions = postJsonHeaders(values)

    let url = Constants.API_ROUTE_CONTENEURS;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then((conteneur) => {
            return conteneur
        });
}

function updateConteneur(id, values) {
    const {id: _id, ...body} = values;
    const requestOptions = patchHeaders(body)
    let url = Constants.API_ROUTE_CONTENEUR.replace(':id', id);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then((conteneur) => {
            return conteneur
        });
}

function deleteConteneur(id) {
    const requestOptions = deleteHeaders()

    let url = Constants.API_ROUTE_CONTENEUR.replace(':id', id);
    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(() => {
            return id
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {

            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
